/**
 * Simple DOM morphing utility
 * Replaces the content of target element with source element
 * @param {Element} target The element to be replaced
 * @param {Element} source The element to replace with
 */
export function morph(target, source) {
  if (!target || !source) {
    console.error('Morph: target or source element is missing');
    return;
  }

  // Store scroll position
  const scrollTop = target.scrollTop;
  const scrollLeft = target.scrollLeft;

  // Replace the innerHTML
  target.innerHTML = source.innerHTML;

  // Copy attributes from source to target
  const sourceAttributes = source.attributes;
  const targetAttributes = target.attributes;

  // Remove attributes that are not in source
  for (let i = targetAttributes.length - 1; i >= 0; i--) {
    const attr = targetAttributes[i];
    if (!source.hasAttribute(attr.name)) {
      target.removeAttribute(attr.name);
    }
  }

  // Add/update attributes from source
  for (const attr of sourceAttributes) {
    target.setAttribute(attr.name, attr.value);
  }

  // Restore scroll position if applicable
  if (scrollTop) target.scrollTop = scrollTop;
  if (scrollLeft) target.scrollLeft = scrollLeft;

  // Trigger a custom event to notify about DOM changes
  target.dispatchEvent(
    new CustomEvent('morphed', {
      detail: { source, target },
      bubbles: true,
    }),
  );
}
